<div menu-content>
	<div class="menu-items">
		<ng-container *ngComponentOutlet="menuContentComponent.component(); inputs: menuContentComponent.inputs()"></ng-container>
		@if (user()) {
			<div class="user-icon">
				@if (isAdmin()) {
					<!-- Admin-only compact timezone dropdown in the header bar -->
					<lb-timezone-selector
						[compact]="true"
						[readonlyMode]="isReadonlyMode()"
						[learnerTimezone]="learnerTimezone() ?? undefined"
						[instructorTimezone]="instructorTimezone() ?? undefined"
						class="header-timezone"
					></lb-timezone-selector>
				}
				<lb-user-menu></lb-user-menu>
			</div>
		}
	</div>
</div>

<ng-container *ngComponentOutlet="mainContentComponent.component(); inputs: mainContentComponent.inputs()"></ng-container>
<lb-breadcrumb></lb-breadcrumb>
